<div class="right-side p-5">
  <!--<div style="text-align:right">Hello {{iaUserName}}</div>-->

  <form [formGroup]="form">

    <div class="section">

      <div class="card mb-3">
        <div class="card-header"> <h2>Personal Details</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <label class="nowrap">Registration<span class="text-danger">*</span></label>
              <input type="text" autocomplete="off" formControlName="registrationId" class="form-control" name="registrationId">
            </div>


            <div class="col-md-3 mb-2">
              <label class="nowrap">Name Of Organisation<span class="text-danger">*</span></label>
              <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="nameOfOrganisation" trimValue id="nameOfOrganisation" class="form-control"
                     name="nameOfOrganisation" placeholder="Name Of Organisation">

            </div>



            <div class="col-md-3 mb-2">
              <label class="nowrap">Address Of Organisation<span class="text-danger">*</span></label>
              <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="addressOfOrganisation" trimValue id="addressOfOrganisation" class="form-control"
                     name="addressOfOrganisation" placeholder="Address Of Organisation">

            </div>

            <div class="col-md-3 mb-2">
              <label class="text-dark">User Name</label>
              <input type="text" class="form-control" formControlName="iaUserName" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <label class="text-dark">Email</label>
              <input type="text" class="form-control" formControlName="email" />
            </div>

            <div class="col-md-3 mb-2">
              <label class="nowrap">Landline Number<span class="text-danger">*</span></label>
              <input type="text" (keypress)="numberanddashOnly($event)" autocomplete="off" formControlName="contactNumber" (input)="formatContactNumber($event)" id="txtContactNumber" class="form-control"
                     name="contactNumber" placeholder="Contact Number" maxlength="12">

            </div>

            <div class="col-md-3 mb-2">
              <label class="text-dark">Mobile Number<span class="text-danger">*</span></label>
              <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="mobileNumber" maxlength="10">

            </div>


          </div>


          <div class="col-md-12">
            <div>
              <!-- Label showing the selected event focus sectors -->
              <label><b>Selected Event Focus Sectors:</b> {{ FocusSectorName }}</label>
            </div>
          </div>

        </div>
      </div>


      <div class="card mb-3">
        <div class="card-header">
          <h2>SPOC Details</h2>
          <h6 style="font-size:smaller;">(SPOC-Single Point of Contact)</h6>
        </div>
        <div class="card-body">
          <div class="row mb-3">


            <div class="table-responsive ">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Email</th>
                    <th>Mobile</th>


                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let record of spocList;let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ record.spocName }}</td>
                    <td>{{ record.spocDesignation }}</td>
                    <td>{{ record.spocEmail }}</td>
                    <td>{{ record.spocMobile }}</td>

                  </tr>
                </tbody>
              </table>
            </div>

          </div>


        </div>
      </div>


      <div class="card mb-3">
        <div class="card-header"><h2>RAMP</h2></div>
        <div class="card-body">


          <div>

            <div class="table-responsive ">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Intervention</th>
                    <th>Component</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pair of selectedPairs; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ pair.interventionName }}</td>
                    <td>{{ pair.interestName }}</td>

                  </tr>

                </tbody>
              </table>

            </div>
          </div>

        </div>
      </div>







      <div class="orginfodiv">
        <div *ngIf="!IsProfileCompleted">
          <form [formGroup]="form2">


            <div class="card mb-3">
              <div class="card-header">  <h2>Organizational Information</h2></div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="nowrap">Bank Name<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="bankName" trimValue id="txtBankName" class="form-control"
                           name="bankName" placeholder="Bank Name">

                  </div>

                  <div class="col-md-3">
                    <label class="nowrap">Account Number<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberOnly($event)" autocomplete="off" formControlName="accountNumber" id="txtAccountNumber" class="form-control"
                           name="accountNumber" placeholder="Account Number" maxlength="18">

                  </div>
                  <div class="col-md-3">
                    <label class="nowrap">IFSC Code<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="ifscCode" id="txtIFSCCode" class="form-control"
                           name="ifscCode" placeholder="IFSC Code">

                  </div>
                  <div class="col-md-3">
                    <label class="nowrap">CIN</label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="cin" trimValue id="txtCIN" class="form-control"
                           name="cin" placeholder="CIN">

                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="nowrap">Organisation PAN<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="organisationPAN" trimValue id="txtOrganisationPAN" class="form-control"
                           name="organisationPAN" placeholder="Organisation PAN">

                  </div>
                  <div class="col-md-3">

                    <div class="form-group">
                      <label for="DateOfIncorporation" class="text-dark">Date Of Incorporation<span class="text-danger">*</span></label>
                      <input type="date" formControlName="dateOfIncorporation" [max]="maxDate" id="txtDateOfIncorporation" name="dateOfIncorporation" placeholder="Date Of Incorporation"
                             class="form-control" />


                    </div>
                  </div>



                  <div class="col-md-3" style="position: relative; z-index: 9999;">
                    <label class="nowrap">GST Number<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="gstNumber" trimValue id="txtGSTNumber" class="form-control"
                           name="gstNumber" placeholder="GST Number">

                  </div>
                  <div class="col-md-3">
                    <label class="nowrap">Person Name<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="personName" trimValue id="txtPersonName" class="form-control"
                           name="personName" placeholder="Person Name">

                  </div>


                </div>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="nowrap">Conatct Number(Landline)</label>
                    <input type="text" (keypress)="numberanddashOnly($event)" autocomplete="off" formControlName="contactNumber" (input)="formatContactNumber($event)" id="txtContactNumber" class="form-control"
                           name="contactNumber" placeholder="Contact Number" maxlength="12">

                  </div>
                  <div class="col-md-3">
                    <label class="nowrap">Mobile Number<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberOnly($event)" autocomplete="off" formControlName="mobileNumber" id="txtMobileNumber" class="form-control"
                           name="mobileNumber" placeholder="Mobile Number" maxlength="10">

                  </div>
                  <div class="col-md-3">
                    <label class="nowrap">Email<span class="text-danger">*</span></label>
                    <input type="text" autocomplete="off" formControlName="email" trimValue id="txtEmail" class="form-control"
                           name="email" placeholder="Email">

                  </div>
                  <div class="col-md-3">
                    <label class="nowrap">Designation<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="textOnly($event)" autocomplete="off" formControlName="designation" id="txtDesignation" class="form-control"
                           name="designation" placeholder="Designation">

                  </div>


                </div>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <div class="form-group mb-2 w-100">
                      <label class="mb-2">IA Logo Image Upload<span class="text-danger">*</span></label>

                      <!--<input class="form-control" type="file" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" />-->
                      <!-- Image Preview from URL -->

                      <div *ngIf="ialogoUrl" class="image-preview mb-2">
                        <img [src]="ialogoUrl" alt="IA Logo Image" class="img-thumbnail" width="150" height="150" />
                      </div>

                      <label class="mb-2">{{ form2.get('iaLogoName')?.value }}</label>


                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group mb-2 w-100">
                      <label class="mb-2">IA Signature Image Upload<span class="text-danger">*</span></label>

                      <!--<input class="form-control" type="file" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" />-->
                      <!-- Image Preview from URL -->

                      <div *ngIf="iasigUrl" class="image-preview mb-2">
                        <img [src]="iasigUrl" alt="IA Signature Image" class="img-thumbnail" width="150" height="150" />
                      </div>

                      <label class="mb-2">{{ form2.get('iaSigName')?.value }}</label>


                    </div>

                    <div class="col-md-3">
                      <label class="nowrap">Which type of GST is applicable?<span class="text-danger">*</span><br></label><br>

                      <!-- Radio Buttons -->
                      <input type="radio" name="gstType" id="cgstsgst" value="CGSTSGST" formControlName="gstType">
                      <label for="cgst">CGST/SGST</label><br>

                      <input type="radio" name="gstType" id="igst" value="IGST" formControlName="gstType">
                      <label for="sgst">IGST</label><br>

                      <!-- Label for GST Percentage (Initially Hidden) -->
                      <label id="gstLabel" style="font-weight: bold;">GST Percent</label>

                      <!-- Text Box (Initially Hidden) -->
                      <input type="text" id="gstPercent" maxlength="2" formControlName="gstPercent" class="form-control mt-2" placeholder="Enter GST percent">
                      <!--<div *ngIf="form2.get('gstPercent')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
      GST percent is required.
    </div>-->
                      <div *ngIf="form2.get('gstPercent')?.touched && f['gstPercent'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['gstPercent'].errors && f['gstPercent'].errors['required']">
                          GST percent is required
                        </div>
                      </div>




                    </div>
                  </div>

                  <!--<div class="col-md-3">
    <label class="text-dark">Brief Background Of IA<span class="text-danger">*</span></label>
    <input type="text" (keypress)="textSpaceCommaOnly($event)" class="form-control" formControlName="briefBackgroundIA" trimValue>


  </div>
  <div class="col-md-3">
    <label class="text-dark">Summary and Scale Of Projects<span class="text-danger">*</span></label>
    <input type="text" (keypress)="textSpaceCommaOnly($event)" class="form-control" formControlName="summaryScaleIA" trimValue>


  </div>-->

                  <div class="row mb-3">

                    <div class="col-md-9">
                      <label class="text-dark">Brief Background Of IA<span class="text-danger">*</span></label>
                      <textarea type="text" class="form-control" formControlName="briefBackgroundIA" trimValue></textarea>
                      <!-- Character count display -->
                      <!--<small class="text-muted">
        {{ f['briefBackgroundIA'].value?.length || 0 }}/2000 characters
      </small>-->
                      <div *ngIf="f['briefBackgroundIA'].touched && f['briefBackgroundIA'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['required']">
                          Brief Background Of IA is required
                        </div>

                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['pattern']">
                          Enter characters only
                        </div>
                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['maxlength']">
                          Maximum length should be 2000 characters
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-9">
                      <label class="text-dark">Summary and Scale Of Projects<span class="text-danger">*</span></label>
                      <textarea type="text" class="form-control" formControlName="summaryScaleIA" trimValue></textarea>
                      <!-- Character count display -->
                      <!--<small class="text-muted">
        {{ f['summaryScaleIA'].value?.length || 0 }}/2000 characters
      </small>-->
                      <div *ngIf="f['summaryScaleIA'].touched && f['summaryScaleIA'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['required']">
                          Summary and Scale Of Projects is required
                        </div>

                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['pattern']">
                          Enter characters only
                        </div>
                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['maxlength']">
                          Maximum length should be 2000 characters
                        </div>
                      </div>

                    </div>
                  </div>

                </div>





              </div>
            </div>

          </form>
        </div>
        <div *ngIf="IsProfileCompleted">
          <form [formGroup]="form2">

            <div class="card mb-3">
              <div class="card-header"> <h2>Organizational Information</h2></div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="text-dark">Bank Name<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="textAndSpaceOnly($event)" class="form-control" formControlName="bankName" trimValue>

                  </div>

                  <div class="col-md-3">
                    <label class="text-dark">Account Number<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="accountNumber" maxlength="18">


                  </div>
                  <div class="col-md-3">
                    <label class="text-dark">IFSC Code<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="ifscCode">


                  </div>
                  <div class="col-md-3">
                    <label class="text-dark">CIN</label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="cin" trimValue>


                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="text-dark">Organisation PAN<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="organisationPAN" trimValue>



                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="text-dark">Date Of Incorporation<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="dateOfIncorporation" />
                      <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']">
                        Date  is required
                      </div>

                    </div>
                  </div>



                  <div class="col-md-3">
                    <label class="text-dark">GST Number<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="gstNumber" trimValue>


                  </div>
                  <div class="col-md-3">
                    <label class="text-dark">Person Name<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="textAndSpaceOnly($event)" class="form-control" formControlName="personName" trimValue>


                  </div>


                </div>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="text-dark">Contact Number(Landline)</label>
                    <input type="text" (keypress)="numberanddashOnly($event)" class="form-control" formControlName="contactNumber" (input)="formatContactNumber($event)" maxlength="12">


                  </div>
                  <div class="col-md-3">
                    <label class="text-dark">Mobile Number<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="mobileNumber" maxlength="10">


                  </div>
                  <div class="col-md-3">
                    <label class="text-dark">Email<span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="email" trimValue>


                  </div>
                  <div class="col-md-3">
                    <label class="text-dark">Designation<span class="text-danger">*</span></label>
                    <input type="text" (keypress)="textOnly($event)" class="form-control" formControlName="designation">


                  </div>


                </div>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <div class="form-group mb-2 w-100">
                      <label class="mb-2">IA Logo Image Upload<span class="text-danger">*</span></label>

                      <!-- Image Preview from URL -->

                      <div *ngIf="ialogoUrl" class="image-preview mb-2">
                        <img [src]="ialogoUrl" alt="IA Logo Image" class="img-thumbnail" width="150" height="150" />
                      </div>

                      <label class="mb-2">{{ form2.get('iaLogoName')?.value }}</label>


                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group mb-2 w-100">
                      <label class="mb-2">IA Signature Image Upload<span class="text-danger">*</span></label>

                      <!--<input class="form-control" type="file" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" />-->
                      <!-- Image Preview from URL -->

                      <div *ngIf="iasigUrl" class="image-preview mb-2">
                        <img [src]="iasigUrl" alt="IA Signature Image" class="img-thumbnail" width="150" height="150" />
                      </div>

                      <label class="mb-2">{{ form2.get('iaSigName')?.value }}</label>


                    </div>
                  </div>

                  <div class="col-md-3">
                    <label class="nowrap">Which type of GST is applicable?<span class="text-danger">*</span><br></label><br>

                    <!-- Radio Buttons -->
                    <input type="radio" name="gstType" id="cgstsgst" value="CGSTSGST" formControlName="gstType" >
                    <label for="cgst">CGST/SGST</label><br>

                    <input type="radio" name="gstType" id="igst" value="IGST" formControlName="gstType" >
                    <label for="sgst">IGST</label><br>

                    <!-- Label for GST Percentage (Initially Hidden) -->
                    <label id="gstLabel" style="font-weight: bold;">GST Percent</label>

                    <!-- Text Box (Initially Hidden) -->
                    <input type="text" id="gstPercent"  maxlength="2" formControlName="gstPercent" class="form-control mt-2" placeholder="Enter GST percent">
                    <!--<div *ngIf="form2.get('gstPercent')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
      GST percent is required.
    </div>-->
                    <div *ngIf="form2.get('gstPercent')?.touched && f['gstPercent'].invalid" class="alert alert-danger required">
                      <div *ngIf="f['gstPercent'].errors && f['gstPercent'].errors['required']">
                        GST percent is required
                      </div>
                    </div>




                  </div>

                  <!--<div class="col-md-3">
    <label class="text-dark">Brief Background Of IA<span class="text-danger">*</span></label>
    <input type="text" (keypress)="textSpaceCommaOnly($event)" class="form-control" formControlName="briefBackgroundIA" trimValue>


  </div>
  <div class="col-md-3">
    <label class="text-dark">Summary and Scale Of Projects<span class="text-danger">*</span></label>
    <input type="text" (keypress)="textSpaceCommaOnly($event)" class="form-control" formControlName="summaryScaleIA" trimValue>


  </div>-->

                  <div class="row mb-3">

                    <div class="col-md-9">
                      <label class="text-dark">Brief Background Of IA<span class="text-danger">*</span></label>
                      <textarea type="text" class="form-control" formControlName="briefBackgroundIA" trimValue></textarea>
                      <!-- Character count display -->
                      <!--<small class="text-muted">
        {{ f['briefBackgroundIA'].value?.length || 0 }}/2000 characters
      </small>-->
                      <div *ngIf="f['briefBackgroundIA'].touched && f['briefBackgroundIA'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['required']">
                          Brief Background Of IA is required
                        </div>

                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['pattern']">
                          Enter characters only
                        </div>
                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['maxlength']">
                          Maximum length should be 2000 characters
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-9">
                      <label class="text-dark">Summary and Scale Of Projects<span class="text-danger">*</span></label>
                      <textarea type="text" class="form-control" formControlName="summaryScaleIA" trimValue></textarea>
                      <!-- Character count display -->
                      <!--<small class="text-muted">
        {{ f['summaryScaleIA'].value?.length || 0 }}/2000 characters
      </small>-->
                      <div *ngIf="f['summaryScaleIA'].touched && f['summaryScaleIA'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['required']">
                          Summary and Scale Of Projects is required
                        </div>

                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['pattern']">
                          Enter characters only
                        </div>
                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['maxlength']">
                          Maximum length should be 2000 characters
                        </div>
                      </div>

                    </div>
                  </div>

                </div>





              </div>
            </div>

            <button class="btn btn-secondary mx-2" (click)="navigateBack()">Back</button>

          </form>
        </div>
      </div>
    </div>
